var map = {
	"./jorin.jpg": 315,
	"./kangaroo.svg": 161,
	"./wildlife/001-deer.svg": 316,
	"./wildlife/002-snake.svg": 317,
	"./wildlife/003-kangaroo.svg": 318,
	"./wildlife/004-hippo.svg": 319,
	"./wildlife/005-koala.svg": 320,
	"./wildlife/006-horse.svg": 321,
	"./wildlife/007-owl.svg": 322,
	"./wildlife/008-goat.svg": 323,
	"./wildlife/009-camel.svg": 324,
	"./wildlife/010-mouse.svg": 325,
	"./wildlife/011-alpaca.svg": 326,
	"./wildlife/012-duck.svg": 327,
	"./wildlife/013-deer.svg": 328,
	"./wildlife/014-elephant.svg": 329,
	"./wildlife/015-crocodile.svg": 330,
	"./wildlife/016-sheep.svg": 331,
	"./wildlife/017-giraffe.svg": 332,
	"./wildlife/018-bear.svg": 333,
	"./wildlife/019-boar.svg": 334,
	"./wildlife/020-buffalo.svg": 335,
	"./wildlife/021-chicken.svg": 336,
	"./wildlife/022-giraffe.svg": 337,
	"./wildlife/023-pawprint.svg": 338,
	"./wildlife/024-dog.svg": 339,
	"./wildlife/025-buffalo.svg": 340,
	"./wildlife/026-snake.svg": 341,
	"./wildlife/027-hedgehog.svg": 342,
	"./wildlife/028-penguin.svg": 343,
	"./wildlife/029-eagle.svg": 344,
	"./wildlife/030-rabbit.svg": 345,
	"./wildlife/031-cat.svg": 346,
	"./wildlife/032-lemur.svg": 347,
	"./wildlife/033-frog.svg": 348,
	"./wildlife/034-lion.svg": 349,
	"./wildlife/035-walrus.svg": 350,
	"./wildlife/036-raccoon.svg": 351,
	"./wildlife/037-hornbill.svg": 352,
	"./wildlife/038-polar bear.svg": 353,
	"./wildlife/039-fox.svg": 354,
	"./wildlife/040-chameleon.svg": 355,
	"./wildlife/041-tiger.svg": 356,
	"./wildlife/042-panda.svg": 357,
	"./wildlife/043-monkey.svg": 358,
	"./wildlife/044-mole.svg": 359,
	"./wildlife/045-squirrel.svg": 360,
	"./wildlife/046-footprint.svg": 361,
	"./wildlife/047-zebra.svg": 362,
	"./wildlife/048-gorilla.svg": 363,
	"./wildlife/049-rhinoceros.svg": 364,
	"./wildlife/050-owl.svg": 365
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 162;